import React, { useEffect, useState } from "react"
import { ListboxButton, ListboxOption } from "@headlessui/react"

import { ListBox } from "../../../lib/fragments/ListBox"
import { FloatingInput } from "../../../components/utils/FloatingInput"
import { FloatingTextArea } from "../../../components/utils/FloatingTextArea"

export const AttributeIdentity = ({ state, setstate, listboxHandler, blurHandler, changeHandler }) => {
    const [focused, setFocused] = useState(false);
    const [hintVisibility, setHintVisibility] = useState(false)
    const isFloating = focused || state.input.name.length > 0;

    const floatingInputBlurHandler = (e: any) => {
        // Floating input to handle the focusing in and out 
        // of floating input
        setFocused(false)
        blurHandler(e)
    }

    const removeHintDescription = () => {
        setHintVisibility(false)

        setstate((prev: any) => ({
            ...prev,
            input: {
                ...prev.input,
                hint: ''
            }, errors: {
                ...prev.errors,
                hint: ''
            }
        }))
    }

    useEffect(() => {
        if (state.input.hint) {
            setHintVisibility(true)
        }
    }, [])

    return (
        <React.Fragment>
            <div className="w-full mb-2 md:pt-0 pt-1 flex flex-col md:h-full flex-1">
                <div className="flex-grow">
                    <p className="md:text-lg text-lg text-slate-900 dark:text-white flex items-center gap-x-3 py-2">
                        <span className="fa-light fa-block-question fa-xl"></span>
                        Attribute Identity
                    </p>

                    <p className="text-xs mb-2 text-slate-500 dark:text-slate-400">
                        {
                            state.payload ? (
                                "Amend attribute's identity and grouping."
                            ) : (
                                'Define the basic identity and grouping of this attribute.'
                            )
                        }
                    </p>

                    <div className="w-full mb-2 py-3 md:max-w-md">
                        <ListBox
                            label={
                                <span className="block text-base text-slate-800 dark:text-slate-200 pb-1">
                                    Grouping

                                    <span className="block text-xs text-slate-500 dark:text-slate-400 py-1">
                                        Choose the most appropriate group for this attribute.
                                    </span>
                                </span>
                            }
                            value={state.input.attr_group ? state.input.attr_group.g : ''}
                            eventHandler={(e: any) => listboxHandler(e, 'attr_group')}
                            button={
                                <>
                                    <ListboxButton className="relative border w-full rounded-md py-2 pr-2 text-left cursor-default focus:ring-primary focus:border-primary sm:text-sm ring-slate-300 dark:ring-slate-600 focus:ring-orange-600 focus:outline-none focus:border-0 focus:ring-primary focus:outline-orange-500 border-slate-300 dark:border-slate-600 dark:text-white">
                                        <div className="flex w-full items-center align-middle">
                                            <div className="flex-grow flex items-center">
                                                <span className="truncate ml-3 font-normal group-data-[selected]:font-semibold">
                                                    {
                                                        state.input.attr_group ? (
                                                            <div className="flex items-center gap-x-4">
                                                                <span className="truncate group-data-[selected]:font-semibold">
                                                                    {state.input.attr_group.e}
                                                                </span>
                                                            </div>
                                                        ) : (
                                                            <span className="text-slate-500 dark:text-slate-300">
                                                                Select attribute group
                                                            </span>
                                                        )
                                                    }
                                                </span>
                                            </div>

                                            <span className="fa-light fa-chevron-down focus:text-primary float-end"></span>
                                        </div>
                                    </ListboxButton>
                                </>
                            }
                            options={
                                <>
                                    {
                                        state.data.groups.length > 0 ? (
                                            state.data.groups.map((group: any) => (
                                                group.n && (
                                                    <ListboxOption key={`usr-attr-band-${group.g}`} value={group.g} className="group relative cursor-default select-none py-2 pl-3 pr-9 data-[selected]:text-orange-600 data-[focus]:bg-slate-100 dark:data-[focus]:bg-slate-900/70 rounded-md w-full data-[selected]:bg-orange-100">
                                                        <div className="flex items-center gap-x-4">
                                                            <span className="truncate group-data-[selected]:font-medium">
                                                                {group.e}

                                                                <span className="block text-xs font-normal text-slate-500 dark:text-slate-400">
                                                                    {group.t}
                                                                </span>
                                                            </span>
                                                        </div>

                                                        <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-orange-600 group-[&:not([data-selected])]:hidden">
                                                            <span className="fa-light fa-check"></span>
                                                        </span>
                                                    </ListboxOption>
                                                )
                                            ))
                                        ) : (
                                            <ListboxOption value={null} className="group relative cursor-default select-none py-2.5 pl-3 pr-9 text-slate-500 data-[focus]:bg-slate-100 dark:data-[focus]:bg-slate-900/70 rounded-md w-full">
                                                <div className="flex items-center gap-x-4">
                                                    <span className="truncate group-data-[selected]:font-medium">
                                                        No Attribute Groups Found
                                                    </span>
                                                </div>

                                                <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-slate-600 group-[&:not([data-selected])]:hidden">
                                                    <span className="fa-light fa-check"></span>
                                                </span>
                                            </ListboxOption>
                                        )
                                    }

                                    {
                                        !state.payload && (
                                            <>
                                                <div className="my-1 w-[95%] mx-auto border-b border-slate-300 dark:border-slate-600"></div>

                                                <ListboxOption value={'__create_new__'} className="group relative cursor-default select-none py-2.5 pl-3 pr-9 text-orange-600 data-[focus]:bg-slate-100 dark:data-[focus]:bg-slate-900/70 rounded-md w-full">
                                                    <div className="flex items-center gap-x-4">
                                                        <span className="truncate group-data-[selected]:font-medium">
                                                            Create attribute group
                                                        </span>
                                                    </div>

                                                    <span className="absolute inset-y-0 right-0 flex items-center pr-4 text-orange-600 group-[&:not([data-selected])]:hidden">
                                                        <span className="fa-light fa-check"></span>
                                                    </span>
                                                </ListboxOption>
                                            </>
                                        )
                                    }
                                </>
                            }
                        />

                        {
                            state.errors.attr_group.length > 0 && (
                                <span className='invalid-feedback text-xs text-red-600 dark:text-red-400 pl-1 pt-1'>
                                    {state.errors.attr_group}
                                </span>
                            )
                        }
                    </div>

                    <div className="w-full pb-3">
                        <span className="block text-base text-slate-800 dark:text-slate-200 pb-3">
                            Naming

                            <span className="block text-xs text-slate-500 dark:text-slate-400 py-1">
                                Name the attribute based on your use case
                            </span>
                        </span>

                        <FloatingInput
                            required={true}
                            name={"name"}
                            posting={state.posting}
                            label={isFloating ? "Attribute Name" : "e.g. Department, Priority Level, Access Role"}
                            changeHandler={changeHandler}
                            value={state.input.name}
                            error={state.errors.name}
                            focusHandler={() => setFocused(true)}
                            blurHandler={(e: any) => floatingInputBlurHandler(e)}
                        />

                        <button type="button" onClick={() => setHintVisibility(true)} className={`text-theme md:py-0 hover:text-orange-700 ${hintVisibility ? 'hidden' : 'block mt-3 md:mb-0 mb-3'}`}>
                            <span className="text-sm">Add Description</span>
                        </button>
                    </div>

                    {
                        hintVisibility && (
                            <div className="w-full pb-3">
                                <span className="block text-base text-slate-800 dark:text-slate-200 pb-2">
                                    <span className="block text-xs text-slate-500 dark:text-slate-400 py-1">
                                        A brief description for others to understand the purpose of this attribute
                                    </span>
                                </span>

                                <FloatingTextArea
                                    required={false}
                                    name={"hint"}
                                    posting={state.posting}
                                    label={
                                        <span className="flex items-center gap-1">
                                            Hint <span className="text-xs text-gray-500 dark:text-gray-400">(Optional)</span>
                                        </span>
                                    }
                                    blurHandler={blurHandler}
                                    changeHandler={changeHandler}
                                    value={state.input.hint}
                                    error={state.errors.hint}
                                />

                                <div className="w-full md:w-auto flex flex-row">
                                    <button type="button" onClick={() => removeHintDescription()} className={`text-red-600 dark:text-red-500 md:py-0 hover:text-red-700 dark:hover:text-red-400`}>
                                        <span className="text-sm">Remove Description</span>
                                    </button>
                                </div>
                            </div>
                        )
                    }
                </div>

                {
                    state.errors.basic.length > 0 && (
                        <div className="flex-none">
                            <span className='text-xs py-2 px-2 rounded-md mb-3 flex align-middle items-center bg-red-100 dark:bg-red-900/40 text-red-600 dark:text-red-400 gap-x-2'>
                                <span className="fa-regular fa-exclamation-circle fa-lg"></span>

                                {state.errors.basic}
                            </span>
                        </div>
                    )
                }
            </div>
        </React.Fragment>
    )
}